
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import databases from '@/views/databases/databases'
import database from '@/views/databases/database'
import routerSrx from './routerSrx'
import routerJy from './routerJy'
import routerLt from './routerLt'
import router from './router'

const _import = require('./_import_' + process.env.NODE_ENV)

Vue.use(Router)

export const asyncRouterMap = [

]

const getRouterMap = function getRouterMap() {  
    if(process.env.BASE_API == "http://139.129.228.212:8090"){
        return routerSrx.constantRouterMap();
    }else if(process.env.BASE_API == "http://api.xingls.cn"){
        return routerJy.constantRouterMap();
    }else if(process.env.BASE_API == "http://47.92.247.126:8090"){
        return routerLt.constantRouterMap();
    }else if(process.env.BASE_API == "https://xcx.xynetweb.com"){
        return router.constantRouterMap();
    }else{
        return router.constantRouterMap();
    }
};

export const constantRouterMap = getRouterMap();

export default new Router({
    routes: constantRouterMap
})

/*  export default new Router({
    routes: constantRouterMap
})*/



// WEBPACK FOOTER //
// ./src/router/index.js